import { render } from "./EntraIdVerifyResult.vue?vue&type=template&id=ca147d2e"
import script from "./EntraIdVerifyResult.vue?vue&type=script&lang=js"
export * from "./EntraIdVerifyResult.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__